import React from 'react';

type Props = {
    className?: string;
};

export const FarewiseIconLight: React.FC<Props> = ({className}) => {
    return (
        <svg className={className} width="60" height="60" viewBox="0 0 79 79" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <rect width="79" height="79" rx="22.8234" fill="#AA76E1"/>
            <path
                d="M51.4197 35.79C49.0744 35.5174 45.4511 35.191 41.5042 35.191C39.0212 35.191 36.4033 35.3177 33.711 35.5683L33.5319 35.3039C32.5486 33.8538 30.9911 32.8884 29.2573 32.6529L26.5443 32.2866C26.0788 32.226 24.7485 32.4684 25.0418 34.0466L27.7865 43.1867C27.9379 43.6949 28.3704 44.0722 28.8951 44.1521C29.0479 44.1769 32.2154 44.6603 36.5961 44.9109C34.1957 49.2916 34.3968 50.4443 34.8388 51.2224C35.1652 51.7953 35.7478 52.123 36.4363 52.123C41.5001 52.123 45.7197 47.7547 47.992 44.8076C49.2865 44.7112 50.4378 44.601 51.3812 44.4978C53.6039 44.2568 55.2812 42.3838 55.2812 40.1405C55.2812 37.9164 53.6218 36.0462 51.4197 35.79Z"
                fill="white"/>
            <path
                d="M41.5055 32.4368C43.6318 32.4368 45.6645 32.5277 47.4672 32.6558C45.1246 29.7872 41.1405 26 36.4362 26C35.7476 26 35.1665 26.3278 34.8387 26.9007C34.4173 27.6402 34.2135 28.7185 36.2696 32.6076C38.0585 32.4946 39.813 32.4368 41.5055 32.4368Z"
                fill="white"/>
        </svg>
    )
}